"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var runHasRole_exports = {};
__export(runHasRole_exports, {
  hasRole: () => hasRole,
  hasWorkspaceRole: () => hasWorkspaceRole
});
module.exports = __toCommonJS(runHasRole_exports);
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
function hasRole(roles, role) {
  if (roles.includes(import_types.superuserRole)) {
    return true;
  } else {
    const parts = (0, import_types.parseRole)(role);
    return roles.some((role2) => {
      const parts2 = (0, import_types.parseRole)(role2);
      switch (parts[0]) {
        case "G":
          return parts2[0] === "G" && (0, import_types.globalRoleLevel)(parts2[1]) >= (0, import_types.globalRoleLevel)(parts[1]);
        case "W":
          return parts2[0] === "W" && (0, import_types.workspaceRoleLevel)(parts2[1]) >= (0, import_types.workspaceRoleLevel)(parts[1]) && parts2[2] === parts[2];
        case "P":
          return parts2[0] === "P" && (0, import_types.projectRoleLevel)(parts2[1]) >= (0, import_types.projectRoleLevel)(parts[1]) && parts2[2] === parts[2];
        case "T":
          return parts2[0] === "T" && (0, import_types.teamRoleLevel)(parts2[1]) >= (0, import_types.teamRoleLevel)(parts[1]) && parts2[2] === parts[2];
        default:
          return (0, import_util.checkExhausted)(parts[0]);
      }
    });
  }
}
function hasWorkspaceRole(roles, name) {
  if (roles.includes(import_types.superuserRole)) {
    return true;
  } else {
    const level = (0, import_types.workspaceRoleLevel)(name);
    switch (name) {
      case "Disabled":
      case "Active":
      case "Admin": {
        const adminLevel = (0, import_types.globalRoleLevel)("Admin");
        return roles.some((role) => {
          const parts = (0, import_types.parseRole)(role);
          return parts != null && (parts[0] === "W" && (0, import_types.workspaceRoleLevel)(parts[1]) >= level || parts[0] === "G" && (0, import_types.globalRoleLevel)(parts[1]) >= adminLevel);
        });
      }
      case "Owner":
        return roles.some((role) => {
          const parts = (0, import_types.parseRole)(role);
          return parts != null && parts[0] === "W" && (0, import_types.workspaceRoleLevel)(parts[1]) >= level;
        });
    }
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  hasRole,
  hasWorkspaceRole
});
//# sourceMappingURL=runHasRole.js.map
